import * as React from 'react';

const SvgBlueAmbBadge = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="blue_amb_badge_svg"
    width={props.width || 201}
    height={props.height || 34}
    viewBox="0 0 201 34"
    {...props}
  >
    <defs>
      <style>
        {'.blue_amb_badge_svg__cls-1{fill:currentColor}.blue_amb_badge_svg__cls-3{fill:#085c7e}'}
      </style>
    </defs>
    <path
      d="M110.4 13c0 5.744-4.656 10.4-10.4 10.4S89.6 18.744 89.6 13 94.256 2.6 100 2.6s10.4 4.656 10.4 10.4Zm-4.002 10.154A11.947 11.947 0 0 1 100 25c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12a11.97 11.97 0 0 1-4.002 8.946v9.028c0 1.244-1.357 2.012-2.423 1.372l-5.165-3.099a.801.801 0 0 0-.824 0l-5.165 3.099c-1.066.64-2.423-.128-2.423-1.372v-9.029c.498.445 1.033.85 1.6 1.208v7.821l5.165-3.099a2.4 2.4 0 0 1 2.47 0l5.165 3.099v-7.82Z"
      style={{
        fillRule: 'evenodd',
        fill: '#085c7e',
      }}
    />
    <path
      d="M117 13h84v1h-84zM0 13h83v1H0zM104.95 11.014l-3.174-.461-1.419-2.876a.402.402 0 0 0-.717 0l-1.419 2.876-3.174.461a.403.403 0 0 0-.229.116.404.404 0 0 0 .007.567l2.296 2.239-.542 3.161a.396.396 0 0 0 .158.391.394.394 0 0 0 .421.03l2.839-1.493 2.838 1.493a.4.4 0 0 0 .58-.421l-.542-3.161 2.296-2.239a.392.392 0 0 0 .116-.229.398.398 0 0 0-.337-.454Z"
      className="blue_amb_badge_svg__cls-3"
    />
    <path
      d="M110.4 12c0 5.744-4.656 10.4-10.4 10.4S89.6 17.744 89.6 12 94.256 1.6 100 1.6s10.4 4.656 10.4 10.4Zm-4.002 10.154A11.947 11.947 0 0 1 100 24c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12a11.97 11.97 0 0 1-4.002 8.946v9.028c0 1.244-1.357 2.012-2.423 1.372l-5.165-3.099a.801.801 0 0 0-.824 0l-5.165 3.099c-1.066.64-2.423-.128-2.423-1.372v-9.029c.498.445 1.033.85 1.6 1.208v7.821l5.165-3.099a2.4 2.4 0 0 1 2.47 0l5.165 3.099v-7.82Z"
      style={{
        fillRule: 'evenodd',
        fill: 'currentColor',
      }}
    />
    <path
      d="M117 12h84v1h-84zM0 12h83v1H0zM104.95 10.014l-3.174-.461-1.419-2.876a.402.402 0 0 0-.717 0l-1.419 2.876-3.174.461a.403.403 0 0 0-.229.116.404.404 0 0 0 .007.567l2.296 2.239-.542 3.161a.396.396 0 0 0 .158.391.394.394 0 0 0 .421.03l2.839-1.493 2.838 1.493a.4.4 0 0 0 .58-.421l-.542-3.161 2.296-2.239a.392.392 0 0 0 .116-.229.398.398 0 0 0-.337-.454Z"
      className="blue_amb_badge_svg__cls-1"
    />
  </svg>
);
export default SvgBlueAmbBadge;
